import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { getTenantSlug } from '../api/client';
import '../App.css';

/**
 * PublicLayout — simple main-content wrapper for unauthenticated public pages.
 * Sidebar was removed (it had a single orphaned "Open events" link); discovery
 * of events and activities is now surfaced on the TenantWelcomePage itself.
 */
const PublicLayout: React.FC = () => {
  const { pathname } = useLocation();
  // The main-domain landing page supplies its own semantic main element.
  if (pathname === '/' && !getTenantSlug()) return <Outlet />;

  return (
    <main className="public-main-content">
      <Outlet />
    </main>
  );
};

export default PublicLayout;
